var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: (_vm.operationType === "add" ? "添加" : "修改") + "联盟账号",
            "close-on-click-modal": false,
            width: "750px",
            top: "5vh",
            "custom-class": "dialog_box",
          },
          on: { close: _vm.onClose },
        },
        [
          _c(
            "div",
            {},
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                    "label-position": "right",
                  },
                },
                [
                  _vm.form.unionCode === "TB"
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "\t淘宝联盟ID (Member ID):",
                                prop: "tbBizBase.memberId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.operationType === "edit",
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.tbBizBase.memberId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.tbBizBase,
                                      "memberId",
                                      $$v
                                    )
                                  },
                                  expression: "form.tbBizBase.memberId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "推广位 PID:",
                                prop: "tbBizBase.pid",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.tbBizBase.pid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.tbBizBase, "pid", $$v)
                                  },
                                  expression: "form.tbBizBase.pid",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "淘宝开放平台AppKey:",
                                prop: "tbBizBase.appKey",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.tbBizBase.appKey,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.tbBizBase, "appKey", $$v)
                                  },
                                  expression: "form.tbBizBase.appKey",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "淘宝开放平台AppSecret:",
                                prop: "tbBizBase.appSecret",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.tbBizBase.appSecret,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.tbBizBase,
                                      "appSecret",
                                      $$v
                                    )
                                  },
                                  expression: "form.tbBizBase.appSecret",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.form.unionCode === "JD"
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "京东联盟ID:",
                                prop: "jdBizBase.unionId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.operationType === "edit",
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.jdBizBase.unionId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.jdBizBase, "unionId", $$v)
                                  },
                                  expression: "form.jdBizBase.unionId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm.form.unionCode === "PDD"
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "多多客ID(duoId):",
                                disabled: _vm.operationType === "edit",
                                prop: "pddBizBase.duoId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.pddBizBase.duoId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.pddBizBase, "duoId", $$v)
                                  },
                                  expression: "form.pddBizBase.duoId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "媒体位ID(mediaId):",
                                prop: "pddBizBase.mediaId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.operationType === "edit",
                                  placeholder: "请输入",
                                },
                                model: {
                                  value: _vm.form.pddBizBase.mediaId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.pddBizBase,
                                      "mediaId",
                                      $$v
                                    )
                                  },
                                  expression: "form.pddBizBase.mediaId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "ClientId:",
                                prop: "pddBizBase.clientId",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.pddBizBase.clientId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.pddBizBase,
                                      "clientId",
                                      $$v
                                    )
                                  },
                                  expression: "form.pddBizBase.clientId",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "ClientSecret:",
                                prop: "pddBizBase.clientSecret",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.pddBizBase.clientSecret,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.pddBizBase,
                                      "clientSecret",
                                      $$v
                                    )
                                  },
                                  expression: "form.pddBizBase.clientSecret",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.form.unionCode === "WPH"
                    ? _c(
                        "div",
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "唯品会联盟appKey:",
                                prop: "wphBizBase.appKey",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.wphBizBase.appKey,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.wphBizBase, "appKey", $$v)
                                  },
                                  expression: "form.wphBizBase.appKey",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "唯品会开放平台App Secret:",
                                prop: "wphBizBase.appSecret",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.wphBizBase.appSecret,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form.wphBizBase,
                                      "appSecret",
                                      $$v
                                    )
                                  },
                                  expression: "form.wphBizBase.appSecret",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "唯品会推广位 PID:",
                                prop: "wphBizBase.pid",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.wphBizBase.pid,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form.wphBizBase, "pid", $$v)
                                  },
                                  expression: "form.wphBizBase.pid",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注:", prop: "tips" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.form.tips,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "tips", $$v)
                          },
                          expression: "form.tips",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.submitForm("formRef")
                            },
                          },
                        },
                        [_vm._v("确认")]
                      ),
                      _vm._v(" "),
                      _vm.operationType === "add"
                        ? _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("formRef")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }